import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { getPetSelector } from '@modules/subscriptions/core/selectors';
import { useSelector } from 'react-redux';
import { SupplementItem } from './SupplementItem';
import { ALL_SUPPLEMENTS, SUPPLEMENT_SLIDER } from '@constants/sliders';
import { Swiper, SwiperSlide } from 'swiper/react';

export const Supplements: React.FC = () => {
  const pet = useSelector(getPetSelector);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleSlideChange = (swiper: any) => {
    setCurrentSlide(swiper.realIndex);
  };

  const currentBoxShadow = ALL_SUPPLEMENTS[currentSlide]?.boxShadow || 'none';
  const prevSlide = (currentSlide - 1 + ALL_SUPPLEMENTS.length) % ALL_SUPPLEMENTS.length;

  return (
    <div className="supplements" style={{ boxShadow: currentBoxShadow }}>
      <h3 className="supplements-title">
        {/* One message rather than three text nodes around a <span>: the
            highlighted words sit mid-sentence and each language puts them in a
            different place. */}
        <FormattedMessage
          id="SUPPLEMENTS.HEADING"
          values={{
            name: pet?.name,
            highlight: (chunks) => <span>{chunks}</span>,
            break: <br />,
          }}
        />
      </h3>
      <div className="supplement-slider-wrapper">
        <Swiper {...SUPPLEMENT_SLIDER} onSlideChange={handleSlideChange}>
          {ALL_SUPPLEMENTS.map((supplement, index) => (
            <SwiperSlide key={supplement.id}>
              <SupplementItem
                item={supplement}
                isActive={index === currentSlide}
                isPrev={index === prevSlide}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="supplement-slider-dots"></div>
        <div className="flex justify-end md:justify-between -mt-[1.1rem] mx-[0.5rem]">
          <div className="custom-swiper-button-next"></div>
          <div className="custom-swiper-button-prev"></div>
        </div>
      </div>

      <Link to="/mitbestellen" className="supplements-link">
        <span className="!text-white bg-secondary uppercase">
          <FormattedMessage id="SUPPLEMENTS.SHOP_NOW" />
        </span>
      </Link>
    </div>
  );
};
